module.exports = __webpack_public_path__ + "static/media/icon.e1144779.png";